import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/motion";

export default function CtaBand() {
  return (
    <section className="bg-white text-ink sec" data-testid="cta-band">
      <div className="wrap text-center">
        <Reveal>
          <h2 className="h-display font-bold text-[38px] sm:text-6xl lg:text-[76px] leading-[1.02]" data-testid="cta-band-headline">
            Have an ESG or sustainability challenge?
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="text-ink/70 text-[16px] sm:text-lg mt-6">Let's turn it into a practical roadmap.</p>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-7 mt-11">
            <Link to="/contact" className="btn-gold px-9 py-4" data-testid="cta-band-book-button">
              Book a Consultation <ArrowRight size={16} />
            </Link>
            <a href="mailto:sarvaritam@gmail.com" className="u-sweep font-bold text-[14px] text-ink hover:text-gold transition-colors" data-testid="cta-band-email-link">
              Email SarvaRitam
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
